export class Country {
  public id: number;
  public iso_code: string;
  public name: string;
  public language_id: number;
  public currency_id: number;
  public language: string;
  public currency: string;

}



// WEBPACK FOOTER //
// ./src/app/models/country.model.ts